import React from "react";
import {
  IconDinas,
  IconHelp,
  IconHistoryIzin,
  IconIzin,
  IconPresensi,
  IconProfile,
  IconReporting,
  IconRiwayat,
} from "../../../assets";

const Button = ({ menu, icontype, text, onClick }) => {
  if (!menu) return null;

  const iconMap = {
    presensi: IconPresensi,
    izin: IconIzin,
    dinas: IconDinas,
    riwayat: IconRiwayat,
    historyizin: IconHistoryIzin,
    reporting: IconReporting,
    profile: IconProfile,
    help: IconHelp,
  };

  const icon = iconMap[icontype];

  return (
    <button
      className="flex flex-col items-center justify-center w-full gap-2 py-2 rounded-xl hover:bg-orange-50 transition active:scale-95"
      onClick={onClick}
    >
      <div
        className="w-12 h-12 flex items-center justify-center rounded-2xl"
        style={{ backgroundColor: "#FFF3CD" }}
      >
        {icon && <img src={icon} alt={text} style={{ width: 28, height: 28 }} />}
      </div>
      <span className="text-xs font-semibold text-gray-600 text-center leading-tight px-1">
        {text}
      </span>
    </button>
  );
};

export default Button;
